import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useParams } from 'react-router-dom'
import { useGetActionsQuery } from './actionsApiSlice'
import { memo } from 'react'
import useAuth from "../../hooks/useAuth"


const Action = ({ actionId }) => {
    const {groupId, type} = useParams()

    const { isTeacher, isAdmin } = useAuth()

    const { action } = useGetActionsQuery("actionsList", {
        selectFromResult: ({ data }) => ({
            action: data?.entities[actionId]
        }),
    })
    const navigate = useNavigate() 

    if (action) {
    const responseId = action?.response?._id;

    const handleEditResponse = () => (responseId)?  navigate(`/${type}/${groupId}/tasks/${action.task}/actions/${action.id}/responses/${responseId}`):navigate(`/${type}/${groupId}/tasks/${action.task}/actions/${action.id}/responses`)
    const editResponseButton =<button className="table__button"   
                            onClick={handleEditResponse} >    
                          הגשה   <FontAwesomeIcon icon={faPenToSquare} />
                            </button>


 

        const handleEdit = () =>  navigate(`/${type}/${groupId}/actions/${actionId}`)
       

        return (
            <tr className="table__row">

                <td className="table__cell action__title">{action.title}   {action.ratio? `(${action.ratio}%)`:""}</td>
                <td className="table__cell action__title">{action.text}</td>
                <td className="table__cell action__type">{action.type}</td>

                <td className="table__cell action__status">

                     {responseId
                        ? <span className="action__status--completed">Completed</span>
                        : <span className="action__status--open">TODO</span>
                    } 
                </td>
                <td className="table__cell">
                    {(isTeacher || isAdmin)?<button
                        className="icon-button table__button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                :
                editResponseButton
                }
                  
                </td>
            </tr>
        )

    } else return null
}

const memoizedAction = memo(Action)

export default memoizedAction